import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotes = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 14,
	viewBox: "0 0 13 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.875 1.9375H2.125C1.87891 1.9375 1.6875 2.15625 1.6875 2.375V11.125C1.6875 11.3711 1.87891 11.5625 2.125 11.5625H8.25V9.375C8.25 8.91016 8.63281 8.5 9.125 8.5H11.3125V2.375C11.3125 2.15625 11.0938 1.9375 10.875 1.9375ZM2.125 12.875C1.14062 12.875 0.375 12.1094 0.375 11.125V2.375C0.375 1.41797 1.14062 0.625 2.125 0.625H10.875C11.832 0.625 12.625 1.41797 12.625 2.375V8.5V8.66406C12.625 9.12891 12.4336 9.56641 12.1055 9.89453L9.61719 12.3828C9.28906 12.7109 8.85156 12.875 8.38672 12.875H8.25H2.125ZM3.875 9.59375C3.875 9.97656 3.57422 10.25 3.21875 10.25C2.83594 10.25 2.5625 9.97656 2.5625 9.59375C2.5625 9.23828 2.83594 8.9375 3.21875 8.9375C3.57422 8.9375 3.875 9.23828 3.875 9.59375ZM3.21875 3.25C3.57422 3.25 3.875 3.55078 3.875 3.90625C3.875 4.28906 3.57422 4.5625 3.21875 4.5625C2.83594 4.5625 2.5625 4.28906 2.5625 3.90625C2.5625 3.55078 2.83594 3.25 3.21875 3.25ZM3.875 6.75C3.875 7.13281 3.57422 7.40625 3.21875 7.40625C2.83594 7.40625 2.5625 7.13281 2.5625 6.75C2.5625 6.39453 2.83594 6.09375 3.21875 6.09375C3.57422 6.09375 3.875 6.39453 3.875 6.75Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgNotes);
export { ForwardRef as ReactComponent };
